import React, { Component } from "react";
import { connect } from "react-redux";
import IntlMessages from "../utils/IntlMessages";
import { checkLogin } from "../utils/apiUtil";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import Authen from "../app/routes/authen";
import { setMenuFooter } from "../actions";
class FooterMobileNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: checkLogin(),
    };
  }

  closeModal = () => {
    this.setState({ modal: false });
  };

  render() {
    const { menuFooterActive } = this.props;
    return (

      <div>
          <div className="footer-mobile-nav-upper" ></div>
          <div className="footer-mobile-nav">
        <div className="container">
          <a
            className={`item ${menuFooterActive === 1 ? "active" : ""}`}
            href="/privilege"
          >
            <div className="icon icon-ico-reward"></div>
            <IntlMessages id="header.privilege"></IntlMessages>
          </a>
          {checkLogin() && checkLogin() === true ? (
            // LOGIN
            <>
               { false && "feature : wishlist" ? <a
                className={`item ${menuFooterActive === 2 ? "active" : ""}`}
                href="/my-favourite"
              >
                <div className="icon icon-ico-favourite"></div>
                <IntlMessages id="header.favourite"></IntlMessages>
              </a> : <a></a>}
              <a
                className={`item ${menuFooterActive === 3 ? "active" : ""}`}
                href="/my-coupon"
              >
                <div className="icon icon-ico-coupon"></div>
                <IntlMessages id="header.mycoupon"></IntlMessages>
              </a>
              <a
                className={`item ${menuFooterActive === 4 ? "active" : ""}`}
                href="/my-profile"
              >
                <div className="icon icon-ico-user"></div>
                <IntlMessages id="header.profile"></IntlMessages>
              </a>
            </>
          ) : (
            <div>
               { false && "feature : wishlist" ? <a
                className={`item ${menuFooterActive === 2 ? "active" : ""}`}
                href="#fav"
                onClick={() => {
                  setMenuFooter(2)
                  this.setState({ modal: true });
                }}
              >
                <div className="icon icon-ico-favourite"></div>
                <IntlMessages id="header.favourite"></IntlMessages>
              </a> : ""}
              <a
                className={`item ${menuFooterActive === 3 ? "active" : ""}`}
                href="#coupon"
                onClick={() => {
                  setMenuFooter(3)
                  this.setState({ modal: true });
                }}
              >
                <div className="icon icon-ico-coupon"></div>
                <IntlMessages id="header.mycoupon"></IntlMessages>
              </a>
              <a
                className={`item ${menuFooterActive === 4 ? "active" : ""}`}
                href="#user"
                onClick={() => {
                  setMenuFooter(4)
                  this.setState({ modal: true });
                }}
              >
                <div className="icon icon-ico-user"></div>
                <IntlMessages id="header.profile"></IntlMessages>
              </a>
              <Modal isOpen={this.state.modal === true}>
                <ModalHeader>Log in</ModalHeader>
                <ModalBody style={{ flex: 1, wordWrap: "break-word" }}>
                  <Authen closeModal={this.closeModal} modalLogin={true} />
                </ModalBody>
              </Modal>
            </div>
          )}
        </div>
      </div>
      {/* <div className="footer-mobile-nav-tmb" ></div> */}
      </div>
    );
  }
}

const mapStateToProps = ({ setting }) => {
  const { locale, menuFooterActive } = setting;
  return { locale, menuFooterActive };
};

export default connect(mapStateToProps, {
  setMenuFooter,
})(FooterMobileNav);
